import { ref } from "vue"
import { defineStore } from "pinia"
import { UseRootStore } from "@/model/RootStore"
import * as apiClient from "@/utils/ApiClient"

export const useAdminUserStore = defineStore("adminUser", () => {
	const rootStore = UseRootStore()
	const users = ref<any[]>([])
	let pendingLoad: Promise<void> | null = null
	let loadedForToken: string | null = null

	function load({ force = false }: { force?: boolean } = {}): Promise<void> {
		if (pendingLoad && !force && loadedForToken === rootStore.userApiToken) return pendingLoad
		loadedForToken = rootStore.userApiToken
		pendingLoad = apiClient.getUsers(rootStore.userApiToken).then(
			response => {
				users.value = response
			},
			error => {
				pendingLoad = null
				throw error
			}
		)
		return pendingLoad
	}

	return { users, load }
})
